/* eslint-disable arrow-body-style */
import MyTable from 'components/UIElements/MyTable';
import { useHistory } from 'react-router-dom';

export default function InsuranceContracts({ endPoint, exportFilename }) {
  const history = useHistory();

  const columns = [
    {
      title: 'Αρ. Συμβολαίου',
      dataIndex: 'policyNumber',
      key: 'policyNumber'
    },
    {
      title: 'Επώνυμο',
      dataIndex: 'lastName',
      key: 'lastName'
    },
    {
      title: 'Όνομα',
      dataIndex: 'firstName',
      key: 'firstName'
    },
    {
      title: 'Αρ. Κυκλοφορίας',
      key: 'plateNumber',
      dataIndex: 'plateNumber'
    },
    {
      title: 'Ημ/νία Έναρξης',
      key: 'startDate',
      dataIndex: 'startDate'
    },
    {
      title: 'Ημ/νία Λήξης',
      key: 'endDate',
      dataIndex: 'endDate'
    },
    {
      title: 'Κατάσταση Συμβολαίου',
      key: 'isActive',
      dataIndex: 'isActive'
    },
    {
      title: 'DeviceType',
      key: 'deviceType',
      dataIndex: 'deviceType'
    }
  ];

  return (
    <MyTable
      onRow={record => {
        return {
          onDoubleClick: () => {
            history.push({
              pathname: `/choices/insurance-contracts/${record.id}`,
              state: { policyNumber: record.policyNumber }
            });
          }
        };
      }}
      columns={columns}
      style={{ cursor: 'pointer' }}
      endPoint={endPoint}
      exportFilename={exportFilename}
    />
  );
}
